import BigNumber from "bignumber.js";
BigNumber.config({
  EXPONENTIAL_AT: [-1e+9, 1e+9],
  DECIMAL_PLACES: 5,
})

export const clampDiscountValue = (
  discount: string | number,
  amount: string | number,
) => {
  const amountValue = new BigNumber(amount || 0);
  if (amountValue.lte(0)) return 0;

  const discountValue = new BigNumber(discount || 0);
  if (discountValue.lte(0)) return 0;

  return Number(BigNumber.min(discountValue, amountValue).toString());
}

// 相加
export const plus = (num1: string, num2: string) => {
  const number1 = new BigNumber(num1 || 0); // 使用 BigNumber 来处理输入值
  const number2 = new BigNumber(num2 || 0);
  const result = number1.plus(number2); // 相加操作
  return result.toString()
}

// A - B
export const minus = (num1: string, num2: string) => {
  const number1 = new BigNumber(num1 || 0); // 使用 BigNumber 来处理输入值
  const number2 = new BigNumber(num2 || 0);
  const result = number1.minus(number2); // 相加操作
  return result.toString()
}

// 相乘
export const multi = (num1: string, num2: string) => {
  const number1 = new BigNumber(num1 || 0);
  const number2 = new BigNumber(num2 || 0);
  const result = number1.multipliedBy(number2);
  return result.toString()
}

export const dp = (num1: string) => {
  const number1 = new BigNumber(num1 || 0);
  return number1.dp(2).toString()
}

// num1 / num2
export const divided = (num1: string, num2: string) => {
  const number1 = new BigNumber(num1 || 0);
  const number2 = new BigNumber(num2 || 0);
  const result = number1.dividedBy(number2);
  return result.toString()
}

/**  通过含税总价计算未税总价
  *  num1: 含税总价
  *  taxRate: 税率
  *  税率计算: 未税总价 = 含税总价 / (1 + 税率)
  */
export const noRateAmount = (num1: string, taxRate: string) => {
  const number1 = new BigNumber(num1 || 0);
  const number2 = new BigNumber(taxRate || 0); // 税率 eg: 0.03

  const taxRateCount = number2.plus(new BigNumber(1)); // 1 + 税率, eg: 1.03
  const noRate = number1.dividedBy(taxRateCount); // 未税总价 = 含税总价 / (1 + 税率)

  return noRate.toString()
};

//保留5位
export const roundToDecimal = (
  num: number | string,
  decimals = 5,
  mode: 'half-up' | 'up' | 'down' = 'up'
) => {
  const rm =
    mode === 'half-up'
      ? BigNumber.ROUND_HALF_UP
      : mode === 'down'
        ? BigNumber.ROUND_DOWN
        : BigNumber.ROUND_UP;
  let newBigNum = new BigNumber(num).decimalPlaces(decimals, rm);
  return newBigNum.toNumber();
};
